import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function Reports() {
  const [products, setProducts] = useState([]);
  const [report, setReport] = useState(null);

  const [pouchRecipe, setPouchRecipe] = useState({});

  const [profitSharing, setProfitSharing] = useState({
    retail: 3,
    Wholesale: 5,
    gst: 5
  });

  const sellingPrice = 35;

  useEffect(() => {
    fetchInventoryproducts();
    fetchPouchreceipe();
  }, []);

  /* ---------------- FETCH INVENTORY ---------------- */

  const fetchInventoryproducts = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutsinventoryproductslists")
      .then((response) => {
        const result = response.data.result;
        const errorcode = response.data.errorCode;
        const message = response.data.Message;

        if (errorcode === 2) {
          Swal.fire({
            icon: "error",
            text: message
          });
          return;
        }

        setProducts(result);
      });
  };

  /* ---------------- FETCH RECIPE ---------------- */

  const fetchPouchreceipe = () => {
    axios
      .get("http://tntyping.com/Adminconsole/api/nutspouchreceipelists")
      .then((response) => {
        const result = response.data.result;
        const errorcode = response.data.errorCode;
        const message = response.data.Message;

        if (errorcode === 2) {
          Swal.fire({
            icon: "error",
            text: message
          });
          return;
        }

        if (errorcode === 0 && result.length > 0) {
          const r = result[0];

          const formattedRecipe = {
            Pistha: parseFloat(r.Pistha),
            Badham: parseFloat(r.Badham),
            Wallnut: parseFloat(r.Wallnut),
            Cashews: parseFloat(r.Cashews),
            Drygrapes: parseFloat(r.Drygrapes),
            Dates: parseFloat(r.Dates),
            Pumpkinseed: parseFloat(r.Pumpkinseed),
            Polypouch: parseFloat(r.Polypouch)
          };

          setPouchRecipe(formattedRecipe);
        }
      });
  };

  /* ---------------- AUTO CALCULATE ---------------- */

  useEffect(() => {
    if (products.length > 0 && Object.keys(pouchRecipe).length > 0) {
      calculateReport(products, pouchRecipe);
    }
  }, [products, pouchRecipe]);

  /* ---------------- UPDATE RECIPE ---------------- */

  const updateRecipe = (name, value) => {
    const updatedRecipe = {
      ...pouchRecipe,
      [name]: parseFloat(value)
    };

    setPouchRecipe(updatedRecipe);
  };

  /* ---------------- CALCULATE REPORT ---------------- */

  const calculateReport = (items, recipe) => {
    let pouchCounts = [];

    const pouchCost = items.reduce((total, item) => {
      const name = item.productname.trim();

      if (recipe[name]) {
        const costPerGram = parseFloat(item.unitprice) / 1000;
        const gramsUsed = recipe[name];

        return total + costPerGram * gramsUsed;
      }

      return total;
    }, 0);

    items.forEach((item) => {
      const name = item.productname.trim();

      if (recipe[name]) {
        const qtyKg = parseFloat(item.qty);
        const gramsAvailable = qtyKg * 1000;
        const gramsNeeded = recipe[name];

        const possiblePouches = gramsAvailable / gramsNeeded;

        pouchCounts.push(possiblePouches);
      }
    });

    const maxPouches =
      pouchCounts.length > 0 ? Math.floor(Math.min(...pouchCounts)) : 0;

    const profitPerPouch = sellingPrice - pouchCost;

    const retailProfit = profitPerPouch - profitSharing.retail;
    const wholesaleProfit = profitPerPouch - profitSharing.Wholesale;
    const gstProfit = profitPerPouch - profitSharing.gst;

    const totalProfit = profitPerPouch * maxPouches;

    setReport({
      pouchCost,
      maxPouches,
      profitPerPouch,
      totalProfit,
      retailProfit,
      wholesaleProfit,
      gstProfit
    });
  };

  /* ---------------- TOTAL COST ---------------- */

  const totalOurAm = products.reduce((total, item) => {
    const name = item.productname.trim();

    if (pouchRecipe[name]) {
      const costPerGram = parseFloat(item.unitprice) / 1000;
      const gramsUsed = pouchRecipe[name];

      return total + costPerGram * gramsUsed;
    }

    return total;
  }, 0);

  /* ---------------- TOTAL WEIGHT ---------------- */

  const totalWeight = Object.values(pouchRecipe).reduce(
    (total, val) => total + val,
    0
  );

  /* ---------------- UI ---------------- */

  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">
        Nuts Production Report
      </h2>

      {/* Recipe Editor */}

      <div className="bg-white rounded-xl shadow p-6">
        <h3 className="text-lg font-semibold mb-4">Pouch Recipe (grams)</h3>

        <div className="grid md:grid-cols-4 gap-4">
          {Object.keys(pouchRecipe).map((item) => (
            <div key={item}>
              <label className="text-sm text-gray-600">{item}</label>

              <input
                type="number"
                step="0.1"
                value={pouchRecipe[item]}
                onChange={(e) => updateRecipe(item, e.target.value)}
                className="w-full border rounded p-2 mt-1"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Inventory Table */}

      <div className="bg-white rounded-xl shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Product</th>
              <th className="p-3 text-left">Qty (kg)</th>
              <th className="p-3 text-left">Unit Price</th>
              <th className="p-3 text-left">Total Price</th>
              <th className="p-3 text-left">Amount Per gm</th>
              <th className="p-3 text-left">Cost to Company</th>
            </tr>
          </thead>

          <tbody>
            {products.map((p) => (
              <tr key={p.id} className="border-t">
                <td className="p-3">{p.productname}</td>
                <td className="p-3">{p.qty}</td>
                <td className="p-3">₹ {p.unitprice}</td>
                <td className="p-3">₹ {(p.qty * p.unitprice).toFixed(2)}</td>
                <td className="p-3">₹ {(p.unitprice / 1000).toFixed(2)}</td>

                <td className="p-3">
                  ₹{" "}
                  {pouchRecipe[p.productname]
                    ? (
                        (p.unitprice / 1000) *
                        pouchRecipe[p.productname]
                      ).toFixed(2)
                    : "0"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Production Report */}

      {report && (
        <div className="bg-white rounded-xl shadow p-6 grid md:grid-cols-4 gap-4">
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Cost to Company</p>
            <p className="text-xl font-bold">
              ₹ {totalOurAm.toFixed(2)} per pouch - {totalWeight} gm
            </p>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Pouch Weight</p>
            <p className="text-xl font-bold">{totalWeight} gm</p>
          </div>

          <div className="bg-green-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Selling Price</p>
            <p className="text-xl font-bold">₹{sellingPrice}</p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Profit per pouch</p>
            <p className="text-xl font-bold">
              ₹{report.profitPerPouch.toFixed(2)}
            </p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Profit after Retail</p>
            <p className="text-xl font-bold">
              ₹{report.retailProfit.toFixed(2)}
            </p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Profit after Wholesale</p>
            <p className="text-xl font-bold">
              ₹{report.wholesaleProfit.toFixed(2)}
            </p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-sm text-gray-500">Profit after GST</p>
            <p className="text-xl font-bold">
              ₹{report.gstProfit.toFixed(2)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}